import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isDefined',
  standalone: false
})
export class IsDefinedPipe implements PipeTransform {

    transform(value: any): boolean {
      return value !== undefined && !Number.isNaN(value);
    }

}
